import React from "react";
import { Link } from "react-router-dom";

const PitchItem = ({
  id,
  name,
  image,
  location,
  slug,
  price,
  status,
  bestSeller,
}) => {
  return (
    <div
      className={`group rounded-2xl shadow-md overflow-hidden w-full max-w-[350px] bg-white transform transition-all duration-300 ${
        status === "active" ? "hover:scale-102 cursor-pointer" : "opacity-80"
      }`}
    >
      <Link to={`/sahalar/${slug}`} className="flex flex-col h-full">
        {/* Image Section */}
        <div className="relative overflow-hidden">
          <img
            src={image}
            alt={name}
            className="w-full h-56 object-cover transition-transform duration-500 group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          {status !== "active" && (
            <div className="absolute inset-0 bg-gray-900/40 flex items-center justify-center">
              <span className="text-white bg-red-600 px-4 py-1.5 rounded-full text-sm font-semibold tracking-wide shadow-md">
                Unavailable
              </span>
            </div>
          )}
          {bestSeller && status === "active" && (
            <div className="absolute top-3 right-3 bg-yellow-400 text-white px-2 py-1 rounded-full text-xs font-semibold flex items-center gap-1 shadow-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                className="w-4 h-4"
              >
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.518 4.67a1 1 0 00.95.69h4.91c.969 0 1.372 1.24.588 1.81l-3.974 2.89a1 1 0 00-.364 1.118l1.518 4.67c.3.921-.755 1.688-1.54 1.118l-3.974-2.89a1 1 0 00-1.176 0l-3.974 2.89c-.785.57-1.84-.197-1.54-1.118l1.518-4.67a1 1 0 00-.364-1.118l-3.974-2.89c-.784-.57-.38-1.81.588-1.81h4.91a1 1 0 00.95-.69l1.518-4.67z" />
              </svg>
              Premium
            </div>
          )}
        </div>

        {/* Content Section */}
        <div className="p-6 flex-1 space-y-3">
          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-1 tracking-tight line-clamp-1 group-hover:text-[#4d9041] transition-colors duration-200">
              {name}
            </h2>
            <p className="text-gray-600 text-sm flex items-center gap-1">
              <span className="text-[#4d9041]">📍</span> {location}
            </p>
          </div>

          <div className="flex items-center justify-between">
            <span className="text-xl font-semibold text-[#4d9041]">
              ₺{price}
              <span className="text-gray-500 text-sm font-normal">/saat</span>
            </span>
          </div>
        </div>

        {/* Button Section */}
        <div className="px-6 pb-6">
          <button
            className={`w-full py-3 rounded-lg text-white font-semibold transition-all duration-300 shadow-md ${
              status === "active"
                ? "bg-[#4d9041] hover:bg-[#62a556] hover:shadow-lg cursor-pointer"
                : "bg-red-500 cursor-not-allowed hover:bg-red-600"
            }`}
          >
            {status === "active" ? "İncele" : "Kapalı"}
          </button>
        </div>
      </Link>
    </div>
  );
};

export default PitchItem;
